import { returnAtIndex } from 'lodash-decorators/utils';
import { ProminenceScoreApiModel } from '../../../api/monitoring/model/prominence-group-api.model';
import { RangeModel } from '../../../Common/Filter/models/range.model';

export enum ProminenceLevel {
    NONE = 'NONE',
    VERY_LOW = 'VERY_LOW',
    LOW = 'LOW',
    MODERATE = 'MODERATE',
    HIGH = 'HIGH',
    VERY_HIGH = 'VERY_HIGH'
}

export class ProminenceScoreModel {
    prominenceLevel: ProminenceLevel;
    prominenceGroupName: string;
    keywords: string[];

    constructor(apiModel?: ProminenceScoreApiModel) {
        if (apiModel) {
            this.prominenceGroupName = apiModel.prominenceGroup?.name;
            this.prominenceLevel = ProminenceScoreModel.getProminenceLevel(apiModel.score);
            this.keywords = apiModel.prominenceGroup?.keywords;
        }
    }

    static getProminenceLevel(numericScore: number) {
        if (numericScore === 0) {
            return ProminenceLevel.NONE;
        } else if (numericScore < 0.30) {
            return ProminenceLevel.VERY_LOW;
        } else if (numericScore < 0.44) {
            return ProminenceLevel.LOW;
        } else if (numericScore < 0.70) {
            return ProminenceLevel.MODERATE;
        } else if (numericScore < 1) {
            return ProminenceLevel.HIGH;
        } else {
            return ProminenceLevel.VERY_HIGH;
        }
    }

    static toRange(level: ProminenceLevel): RangeModel {
        switch (level) {
            case ProminenceLevel.NONE:
                return {
                    min: 0,
                    max: 0
                };
            case ProminenceLevel.VERY_LOW:
                return {
                    min: 0.1,
                    max: 0.29
                };
            case ProminenceLevel.LOW:
                return {
                    min: 0.30,
                    max: 0.43
                };
            case ProminenceLevel.MODERATE:
                return {
                    min: 0.44,
                    max: 0.69
                };
            case ProminenceLevel.HIGH:
                return {
                    min: 0.7,
                    max: 0.99
                };
            case ProminenceLevel.VERY_HIGH:
                return {
                    min: 1,
                    max: 1
                };
        }
    }

    static getProminenceLabel(level: ProminenceLevel) {
        switch (level) {
            case ProminenceLevel.NONE:
                return 'Mention.details.prominenceLevel.none';
            case ProminenceLevel.LOW:
                return 'Mention.details.prominenceLevel.low';
            case ProminenceLevel.VERY_LOW:
                return 'Mention.details.prominenceLevel.veryLow';
            case ProminenceLevel.MODERATE:
                return 'Mention.details.prominenceLevel.moderate';
            case ProminenceLevel.HIGH:
                return 'Mention.details.prominenceLevel.high';
            case ProminenceLevel.VERY_HIGH:
                return 'Mention.details.prominenceLevel.veryHigh';
        }
    }
}

